import React, { useState, useEffect } from 'react';

import FieldSetFormControl from '../component/FieldSetFormControl';
import HexStringTextField from '../component/HexStringTextField';
import MultilineTextField from '../component/MultilineTextField';

import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

import { ethers } from 'ethers';

function RLP (props) {
  const {
    classes,
    ...other
  } = props;

  const [ mode, setMode ] = useState ('encode');
  const [ rlp, setRLP ] = useState ('');
  const [ json, setJSON ] = useState ('');
  const [ errorMessage, setErrorMessage ] = useState (undefined);

  useEffect (() => {
    if (mode === 'encode') {
      try {
        setRLP (ethers.utils.RLP.encode (JSON.parse (json)));
        setErrorMessage (undefined);
      } catch (error) {
        setRLP ('');
        setErrorMessage (error.message)
      }
    } else {
      try {
        setJSON (JSON.stringify (ethers.utils.RLP.decode (rlp.trim ())));
          setErrorMessage (undefined);
      } catch (error) {
        setJSON ('');
        setErrorMessage (error.message)
      }
    }
  }, [ mode, json, rlp ]);

  const decoded = (
    <Box component={FieldSetFormControl}
         fullWidth>
      <Box my={1}
           component={MultilineTextField}
           label="JSON"
           readOnly={mode === 'decode'}
           placeholder="[&quot;0x0000...&quot;, ...]"
           value={json}
           validator={() => errorMessage}
           onChange={event => setJSON (event.target.value)} />
    </Box>
  );

  const encoded = (
    <Box component={FieldSetFormControl}
         fullWidth>
      <Box my={1}
           component={HexStringTextField}
           label="RLP"
           readOnly={mode === 'encode'}
           value={rlp}
           validator={() => errorMessage}
           onChange={event => setRLP (event.target.value)} />
    </Box>
  );

  return (
    <Box my={-1}
         component={FieldSetFormControl}
         fullWidth 
         {...other}>
      <Box my={1}
           component={RadioGroup}
           row
           value={mode}
           onChange={event => setMode (event.target.value)}>
        <FormControlLabel label="Encode"
                          control={<Radio />}
                          value="encode" />
        <FormControlLabel label="Decode"
                          control={<Radio />}
                          value="decode" />
      </Box>
      { mode === 'encode' ? decoded : encoded }
      <Box mt={1}
           mb={3}>
        <Divider />
      </Box>
      { mode === 'encode' ? encoded : decoded }
    </Box>
  );
}

export default RLP;
